module.exports = "dialog_component.js-latex-is-open, .mat-dialog-content.js-latex-is-open {\n  max-height: 32vh; }\n"